import { Box, styled } from "@mui/material";
import { HEADER, NAVBAR } from "config";
import useCollapseDrawer from "hooks/useCollapseDrawer";
import EmailHeader from "pages/email_send_page/header/EmailHeader";
import { Outlet } from "react-router-dom";

type MainStyleProps = {
  collapseClick: boolean;
};

const MainStyle = styled("main", {
  shouldForwardProp: (prop) => prop !== "collapseClick",
})<MainStyleProps>(({ collapseClick, theme }) => ({
  flexGrow: 1,
  paddingTop: HEADER.MOBILE_HEIGHT,
  paddingBottom: HEADER.MOBILE_HEIGHT,
  [theme.breakpoints.up("lg")]: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 10,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT - 30,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: theme.transitions.create("margin-left", {
      duration: theme.transitions.duration.shorter,
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH,
    }),
  },
}));

interface AuthLayoutProps {
  children?: any;
}

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const { collapseClick, isCollapse } = useCollapseDrawer();
  return (
    <Box sx={{ display: "flex", minHeight: "100vh" }}>
      <EmailHeader />
      <MainStyle collapseClick={collapseClick}>
        <Box sx={{ pb: 5 }}>{children ? children : <Outlet />}</Box>
      </MainStyle>
    </Box>
  );
};

export default AuthLayout;
